<template id="account">
<section :class="ebranch == null?'contentArea':'accountPage'">
  <form name="account" autocomplete="off">
  <branch :mode="bmode" v-if="ebranch != null" :info="ebranch" :res="res"></branch>
  <div class="container" v-if="ebranch == null">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12" v-if="company.managers != null">
        <div class="formHeadings"> <span><img src="@/images/icon-managers.png" alt=""></span>{{common_res.managers.assigned}}</div>
      </div>

      <div class="col-md-offset-1 col-md-10 col-sm-12 mb-5" v-if="company.managers != null">
        <div class="datacards">
          <template v-for="(manager, midx) in company.managers">
            <manager :idx="midx" :manager="manager" :common_res="common_res" :res="res" v-bind:key="manager.managerid"/>
          </template>
        </div>
      </div>

      
      <div class="col-xs-12">
        <div class="redBarOuter acoountRed">
          <div class="redbar">
            <div class="icon"><img alt="#" src="@/images/rednotification.png"></div>
            <div class="warning-text">
              <p v-html="res.msg"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="formHeadings"> <span><img src="@/images/primarybusiness.png" alt="#"></span>{{res.bizinfo}}</div>
      </div>
      <div class="col-md-10 col-sm-10 col-md-offset-1 col-sm-offset-1 col-xs-12 col-xs-offset-0">
        <div class="col-xs-12">
          <div class="topText">
            <p>{{res.compname}}</p>
            <span v-html="company.name"></span> </div>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <inputbox v-model="company.poc" :isfloat="false" :res="res" :name="'poc'" :title="res.poc"></inputbox>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <div class="inputBlock">
            <inputbox v-model="company.tel" :isfloat="false" :res="res" :name="'tel'" :title="res.tel"></inputbox>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12">
          <inputbox v-model="company.email" :isfloat="false" :res="res" :name="'email'" :title="res.email"></inputbox>
        </div>
        <div class="col-xs-12" v-if="bizname">
          <div class="topText">
            <p>{{res.biz}}</p>
            <span v-text="bizname"></span> </div>
        </div>
        <div class="col-xs-12">
          <inputbox v-model="company.website" :isfloat="false" :res="res" :name="'website'" :title="res.website"></inputbox>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="socialBlk">
            <p>{{res.fb}}</p>
            <span>{{res.fb_url}}</span> </div>
        </div>
        <div class="col-md-8 col-sm-6 col-xs-12">
          <inputbox v-model="company.fb" :isfloat="false" :res="res" :name="'fb'"></inputbox>
          <!--div class="inputBlock outerDiv">
            <input type="input" id="input" class="form-control inputText" placeholder="alphabeta">
          </div-->
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="socialBlk">
            <p>{{res.ig}}</p>
            <span>{{res.ig_url}}</span> </div>
        </div>
        <div class="col-md-8 col-sm-6 col-xs-12">
          <inputbox v-model="company.ig" :isfloat="false" :res="res" :name="'ig'"></inputbox>
          <!--div class="inputBlock outerDiv">
            <input type="input" id="input" class="form-control inputText" placeholder="alphabeta">
          </div-->
        </div>
        <div class="col-xs-12"> 
          <!--div class="selOuter selOuter01"-->
          <div class="inputBlock">
            <label>{{res.lang}}</label>
            <dl id="sample" class="dropdownSel dropdownSel01">
              <dt>
                <a v-on:click="showLocale = !showLocale" href="javascript:void(0)">
                  <span v-if="comlocale == null">{{res.plsselect}}</span>
                  <span v-else>{{comlocale.name}}<span class="value">{{comlocale.id}}</span></span>
                </a>
              </dt>
              <dd>
                <ul :style="showLocale?'display:block;':'display:none;'">
                  <li v-for="(locale, lidx) in locales"><a href="javascript:void(0)" v-on:click="chooseLocale($event, locale)">{{locale.name}}<span class="value">{{locale.id}}</span></a></li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class=" col-md-12 col-sm-12 col-xs-12">
        <div class="formHeadings"> <span><img src="@/images/shipping.png" alt="#"></span>{{res.shipinfo}}</div>
      </div>
      <div class="col-md-offset-1 col-sm-offset-1 col-xs-offset-0 col-md-10 col-sm-10 col-xs-12">
        <inputbox v-model="company.address1" :isfloat="true" :res="res" :name="'address1'" :title="res.address1"></inputbox>
        <inputbox v-model="company.address2" :isfloat="true" :res="res" :name="'address2'" :title="res.address2"></inputbox>
        <inputbox v-model="company.address3" :isfloat="true" :res="res" :name="'address3'" :title="res.address3"></inputbox>
        <inputbox v-model="company.address4" :isfloat="true" :res="res" :name="'address4'" :title="res.address4"></inputbox>
        <inputbox v-model="company.country_name" :isfloat="true" :res="res" :name="'country'" readOnly=true :title="res.country"></inputbox>
        <div v-if="1==2" id="a_deliveryremark" class="inputBlock"><label class="floatLeft" for="" v-html="res.deliveryremark"></label>
          <textarea name="deliveryremark" v-model="company.deliveryremark" class="form-control inputText floatRight inputRightAligned" style="border-radius:8px !important"></textarea>
          <div class="clearFix"></div>
        </div>
      </div>
      
      <div class=" col-md-12 col-sm-12 col-xs-12" id="a_pwd">
        <div class="formHeadings"> <span><img src="@/images/passthumb.png" alt=""></span>{{res.chgpwd}}</div>
      </div>
      <div class="col-md-offset-1 col-md-6 col-sm-6">
        <inputbox v-model="company.ppassword" :boxtype="'password'" :isfloat="false" :res="res" :name="'ppassword'" :title="res.ppassword"></inputbox>
        <inputbox v-model="company.password" :boxtype="'password'" :isfloat="false" :res="res" :name="'password'" :title="res.password"></inputbox>
        <inputbox v-model="company.cpassword" :boxtype="'password'" :isfloat="false" :res="res" :name="'cpassword'" :title="res.cpassword"></inputbox>
        <!--div class="inputBlock">
          <label for="exampleInputPassword1">Confirm password</label>
          <input class="form-control inputText" id="exampleInputPassword1" placeholder="" type="password">
        </div-->
      </div>
      <!--div class=" col-md-12 col-sm-12 col-xs-12">
        <div class="formHeadings"> <span><img src="@/images/verifythumb.png" alt=""></span>Verify your account before update</div>
      </div>
      <div class="col-md-offset-1 col-md-6 col-sm-6">
        <div class="inputBlock">
          <label for="exampleInputEmail">Login email</label>
          <input class="form-control inputText" id="exampleInputemail" placeholder="" type="email" v-model="account.email">
        </div>
      </div-->
      <div class="col-md-12 col-sm-12 col-xs-12 text-center">
        <input type="button" class="form-control submitButton updateButton" :value="res.edit" v-on:click="updAccount($event)">
      </div>
      <div class=" col-md-12 col-sm-12 col-xs-12">
        <div class="formHeadings"> <span><img src="@/images/creatbranch.png" alt="#"></span>{{res.branch}}</div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 accttable" v-if="branches != null && branches.length > 0">
        <div id="no-more-tables">
          <div class="table-responsive">
            <table class="table02 table accountTable">
              <thead>
                <tr>
                  <th>{{res.branch}}</th>
                  <th>{{res.login}}</th>
                  <th>{{res.contact}}</th>
                  <th>{{res.phone}}</th>
                  <th>{{res.address}}</th>
                  <th>{{res.action}}</th>
                </tr>
              </thead>
              <tbody>
              <tr :class="(bidx % 2 == 0)?'lightGrey':'darkGrey'" v-for="(branch, bidx) in branches">
                <td data-title="Branch">{{branch.name}}</td>
                <td data-title="Login email">{{branch.email==''?'----':branch.email}}</td>
                <td data-title="Contact">{{branch.poc}}</td>
                <td data-title="Phone">{{branch.tel}}</td>
                <td data-title="Address">
                  <div v-if="branch.address1 != ''">{{branch.address1}}</div>
                  <div v-if="branch.address2 != ''">{{branch.address2}}</div>
                  <div v-if="branch.address3 != ''">{{branch.address3}}</div>
                  <div v-if="branch.address4 != ''">{{branch.address4}}</div>
                </td>
                <td data-title="Action" :isactive="branch.isactive">
                  <div style="cursor:pointer" class="edit" v-on:click="editBranch($event, branch)"><img class="img-responsive" src="@/images/editthumb.png" alt="">{{res.edit}}</div>
                  <div style="cursor:pointer" v-on:click="disableBranch($event, branch, '0')" v-if="branch.isactive == '1'" class="disable"><img class="img-responsive" src="@/images/disablethumb.png" alt="">{{res.disable}}</div>
                  <div style="cursor:pointer" v-on:click="disableBranch($event, branch, '1')" v-else class="disable"><img class="img-responsive" src="@/images/disablethumb.png" alt="">{{res.enable}}</div>
                  <div style="cursor:pointer" v-on:click="deleteBranch($event, branch)" class="delete"><img class="img-responsive" src="@/images/crossthumb.png" alt="">{{res.delete}}</div>
                </td>
              </tr>
            </tbody></table>
          </div>
        </div>
      </div>
      <div class="col-xs-12 mobileTable customFull hidden">
        <table class="table">
          <tbody><tr>
            <td class="red">Branch</td>
            <td>Primary</td>
          </tr>
          <tr>
            <td class="red">Login email</td>
            <td>sam@abc.com</td>
          </tr>
          <tr>
            <td class="red">Contact</td>
            <td>Sam Smith</td>
          </tr>
          <tr>
            <td class="red">Phone</td>
            <td>+852 9876-5432</td>
          </tr>
          <tr>
            <td class="red">Address</td>
            <td>A-C, 38/F, DOS Building, Floppy Road,<br>
              Lai Chi Kok, Kowloon<br>
              Hong Kong</td>
          </tr>
          <tr>
            <td class="red noBorder">Action</td>
            <td class="noBorder"><img class="img-responsive" src="@/images/editthumb.png" alt=""><span>Edit</span></td>
          </tr>
        </tbody></table>
        <table class="table">
          <tbody><tr>
            <td class="red">Branch</td>
            <td>Causeway bay</td>
          </tr>
          <tr>
            <td class="red">Login email</td>
            <td>kathy@abc.com</td>
          </tr>
          <tr>
            <td class="red">Contact</td>
            <td>Kathy Smith</td>
          </tr>
          <tr>
            <td class="red">Phone</td>
            <td>+852 9876-5544</td>
          </tr>
          <tr>
            <td class="red">Address</td>
            <td>No 1024, Punch Card Drive,<br>
              Causeway bay,<br>
              Hong Kong</td>
          </tr>
          <tr>
            <td class="red noBorder">Action</td>
            <td class="noBorder"><div class="edit"><img class="img-responsive" src="@/images/editthumb.png" alt=""><span>Edit</span></div>
              <div class="disable"><img class="img-responsive" src="@/images/disablethumb.png" alt=""><span>Disable</span></div>
              <div class="delete"><img class="img-responsive" src="@/images/crossthumb.png" alt=""><span>Delete</span></div></td>
          </tr>
        </tbody></table>
        <table class="table">
          <tbody><tr>
            <td class="red">Branch</td>
            <td>Tsuen wan</td>
          </tr>
          <tr>
            <td class="red">Login email</td>
            <td>candy@abc.com</td>
          </tr>
          <tr>
            <td class="red">Contact</td>
            <td>Candy Gam</td>
          </tr>
          <tr>
            <td class="red">Phone</td>
            <td>+852 2348-8347</td>
          </tr>
          <tr>
            <td class="red">Address</td>
            <td>17B, Tsuen Fung Centre,<br>
              Tsuen Wan, NT,<br>
              Hong Kong</td>
          </tr>
          <tr>
            <td class="red noBorder">Action</td>
            <td class="noBorder"><div class="edit"><img class="img-responsive" src="@/images/editthumb.png" alt=""><span>Edit</span></div>
              <div class="disable"><img class="img-responsive" src="@/images/disablethumb.png" alt=""><span>Disable</span></div>
              <div class="delete"><img class="img-responsive" src="@/images/crossthumb.png" alt=""><span>Delete</span></div></td>
          </tr>
        </tbody></table>
      </div>
      <!----------->
      <div class="col-md-12 col-sm-12 col-xs-12 fullTable hidden">
        <div class="acct">
          <ul>
            <li class="redcolor"><span> Branch </span></li>
            <li class="redcolor"><span> Login Email </span></li>
            <li class="redcolor"><span> Contact </span></li>
            <li class="redcolor"><span> Phone </span></li>
            <li class="redcolor"><span> Address </span></li>
            <li class="redcolor"><span> Action </span></li>
          </ul>
          <ul>
            <li class="lightgrey"><span> Primary </span></li>
            <li class="lightgrey"><span> sam@abc.com </span></li>
            <li class="lightgrey"> <span> Sam Smith </span></li>
            <li class="lightgrey"><span> +852 9876-5432 </span></li>
            <li class="lightgrey"><span> A-C, 38/F, DOS Building, Floppy Road, <br>
              Lai Chi Kok, Kowloon <br>
              Hong Kong </span><!--/li-->
            </li><li class="lightgrey"><span>
              <div class="edit"><img class="img-responsive" src="@/images/editthumb.png" alt=""> Edit </div>
              </span></li>
          </ul>
          <ul>
            <li class="darkgrey"><span> Causeway bay </span></li>
            <li class="darkgrey"><span> kathy@abc.com </span></li>
            <li class="darkgrey"> <span> Kathy Smith </span></li>
            <li class="darkgrey"><span> +852 9876-5544 </span></li>
            <li class="darkgrey"><span> No 1024, Punch Card Drive,<br>
              Causeway bay,<br>
              Hong Kong</span><!--/li-->
            </li><li class="darkgrey"><span>
              <div class="edit"><img class="img-responsive" src="@/images/editthumb.png" alt=""> Edit </div>
              <div class="edit"><img class="img-responsive" src="@/images/disablethumb.png" alt=""> Disable </div>
              <div class="edit"><img class="img-responsive" src="@/images/crossthumb.png" alt=""> Delete </div>
              </span></li>
          </ul>
          <ul>
            <li class="lightgrey"><span> Tsuen wan </span></li>
            <li class="lightgrey"><span> candy@abc.com </span></li>
            <li class="lightgrey"> <span> Candy Gam </span></li>
            <li class="lightgrey"><span> +852 2348-8347</span></li>
            <li class="lightgrey"><span> 17B, Tsuen Fung Centre,<br>
              Tsuen Wan, NT,<br>
              Hong Kong </span><!--/li-->
            </li><li class="lightgrey"><span>
              <div class="edit"><img class="img-responsive" src="@/images/editthumb.png" alt=""> Edit </div>
              <div class="edit"><img class="img-responsive" src="@/images/disablethumb.png" alt=""> Disable </div>
              <div class="edit"><img class="img-responsive" src="@/images/crossthumb.png" alt=""> Delete </div>
              </span></li>
          </ul>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 fullTable hidden">
        <div class="acctmob">
          <ul>
            <li>
              <div class="leftacct"> Branch </div>
              <div class="righttacct"> Primary</div>
            </li>
            <li>
              <div class="leftacct"> Login Email </div>
              <div class="righttacct"> sam@abc.com</div>
            </li>
            <li>
              <div class="leftacct"> Contact </div>
              <div class="righttacct"> Sam Smith </div>
            </li>
            <li>
              <div class="leftacct"> Phone </div>
              <div class="righttacct"> +852 9876-5432 </div>
            </li>
            <li>
              <div class="leftacct"> Address </div>
              <div class="righttacct"> A-C, 38/F, DOS Building, Floppy Road, <br>
                Lai Chi Kok, Kowloon <br>
                Hong Kong </div>
            </li>
            <li>
              <div class="leftacct"> Action </div>
              <div class="righttacct">
                <div class="editmob"><img class="img-responsive" src="@/images/editthumb.png" alt=""> <span> Edit </span></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="acctmob">
          <ul>
            <li>
              <div class="leftacct"> Branch </div>
              <div class="righttacct"> Causeway bay </div>
            </li>
            <li>
              <div class="leftacct"> Login Email </div>
              <div class="righttacct"> kathy@abc.com </div>
            </li>
            <li>
              <div class="leftacct"> Contact </div>
              <div class="righttacct"> Kathy Smith </div>
            </li>
            <li>
              <div class="leftacct"> Phone </div>
              <div class="righttacct"> +852 9876-5544 </div>
            </li>
            <li>
              <div class="leftacct"> Address </div>
              <div class="righttacct"> No 1024, Punch Card Drive,<br>
                Causeway bay,<br>
                Hong Kong </div>
            </li>
            <li>
              <div class="leftacct"> Action </div>
              <div class="righttacct">
                <div class="editmob"><img class="img-responsive" src="@/images/editthumb.png" alt=""> <span> Edit </span></div>
                <div class="editmob"><img class="img-responsive" src="@/images/disablethumb.png" alt=""> <span> Disable </span></div>
                <div class="editmob"><img class="img-responsive" src="@/images/crossthumb.png" alt=""> <span> Delete </span></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="acctmob">
          <ul>
            <li>
              <div class="leftacct"> Branch </div>
              <div class="righttacct"> Tsuen wan </div>
            </li>
            <li>
              <div class="leftacct"> Login Email </div>
              <div class="righttacct"> candy@abc.com </div>
            </li>
            <li>
              <div class="leftacct"> Contact </div>
              <div class="righttacct"> Candy Gam </div>
            </li>
            <li>
              <div class="leftacct"> Phone </div>
              <div class="righttacct"> +852 2348-8347</div>
            </li>
            <li>
              <div class="leftacct"> Address </div>
              <div class="righttacct"> 17B, Tsuen Fung Centre,<br>
                Tsuen Wan, NT,<br>
                Hong Kong </div>
            </li>
            <li>
              <div class="leftacct"> Action </div>
              <div class="righttacct">
                <div class="editmob"><img class="img-responsive" src="@/images/editthumb.png" alt=""> <span> Edit </span></div>
                <div class="editmob"><img class="img-responsive" src="@/images/disablethumb.png" alt=""> <span> Disable </span></div>
                <div class="editmob"><img class="img-responsive" src="@/images/crossthumb.png" alt=""> <span> Delete </span></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!---------->
      <div class="col-md-12 col-sm-12 col-xs-12 text-center">
        <input type="button" v-on:click="createBranch($event)" class="form-control submitButton branchBtn" :value="res.createb">
      </div>
    </div>
  </div>
  </form>
</section>
</template>

<script>

import utils from './Utils.vue'
import branch from './Branch.vue'
import inputbox from './InputBox.vue'
import manager from './Manager.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'account',
  props:['name', 'account', 'firstamts', 'countries', 'common_res', 'res', 'locales'],
  data () {
    return {
      ebranch:null,
      showLocale:false,
      company:null,
      comlocale:null,
      branches:[],
      token:null,
      bmode:null,
      submitted:false
    }
  },
  components: {
    branch,
    inputbox,
    manager
  },
  computed: {
    bizname:function() {
      if (this.company.biznature == null) {
        return null;
      } else if (this.company.biznature != '') {
        return $('<div>'+this.company.biznature+'</div>')[0].textContent;
      } else {
        return null;
      }
    }
  },
  created: function() {
    var self = this;
    this.locale = utils.getLocale();
    if (this.account.company == null) {
      this.ebranch = this.account.branches[0];
      this.bmode = 'edit';
    } else {
      this.company = this.account.company;
      if (this.company.locale != null) {
        for (var i=0;i<this.locales.length;i++) {
          if (this.locales[i].id == this.company.locale) {
            this.comlocale = this.locales[i];
            break;
          }
        }
      }
      this.branches = this.account.branches;
      this.bmode = null;
    }
    this.$root.$on('savedCompany', data => {
      if (this.comlocale != null) {
        Vue.cookie.set('locale', this.comlocale.id);
      }
      //window.location.reload();
      self.showDone(this.common_res.message.updated, this.common_res.message.close);
      window.scrollTo(0,0);
    });
    this.$root.$on('savedBranch', data => {
      if (data != null) {
        if (data.saved) {
          if (data.mode == 'ins') {
            this.branches.push(data.saved);
          } else {
            for (var i=0;i<this.branches.length;i++) {
              if (this.branches[i].bchid == data.saved.bchid) {
                this.branches.splice(i, 1, data.saved);
                break;
              }
            }
          }
        }
      }
      if (this.bmode != 'edit') {
        this.ebranch = null;
      }
      self.showDone(this.common_res.message.updated, this.common_res.message.close);
      window.scrollTo(0,0);
    });
    this.$root.$on('cancelBranch', data => {
      this.ebranch = null;
      window.scrollTo(0,0);
    });
  },
  methods: {
    showDone:function(msg, button) {
      this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':msg, 'icon':'fa-check', 'button':button, 'timeout':2000});
    },
    editBranch: function(evt, b) {
      this.ebranch = JSON.parse(JSON.stringify(b));
      window.scrollTo(0,0);
    },
    disableBranch: function(evt, b, a) {
        var self = this;
        utils.saveData({
            url: utils.getServerPath()+'/account/disableBranch.is',
            mode: 'update',
            repos: 'db',
            value: utils.saveJSONToForm({'bchid':b.bchid, 'isactive':a}),
            name: 'account.branch'
          }, function(success, data) {
            if (success) {
              b.isactive = a;
            }
            self.$forceUpdate();
          });
    },
    deleteBranch: function(evt, b) {
        var self = this;
        var buttons = [
          {
            "value":this.common_res.message.yes,
            "func":function() {
              utils.saveData({
                  url: utils.getServerPath()+'/account/deleteBranch.is',
                  mode: 'update',
                  repos: 'db',
                  value: utils.saveJSONToForm({'bchid':b.bchid}),
                  name: 'account.branch'
                }, function(success, data) {
                  if (success) {
                    if (data.success == 1) {
                      for (var i=0;i<self.branches.length;i++) {
                        if (self.branches[i].bchid == b.bchid) {
                          self.branches.splice(i, 1);
                          break;
                        }
                      }
                      self.showDone(self.common_res.message.deleted, self.common_res.message.close);
                    }
                  }
              });
            }
          },
          {
            "value":this.common_res.message.no
          }
        ];
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.res.confirm_delete, 'icon':'fa-question', 'buttons':buttons});
    },
    updAccount: function(response) {
      if (this.submitted) return;
      this.submitted = true;
      var self = this;
      var isok = true;
      var goto = null;
      if (response != null) {
        try {
          this.company['g-recaptcha-response'] = response;
        } catch (e) {}
      }
      if (!this.chk('name', /^.{1,}$/, this.res.name_err)) {
        isok = false;
        if (!goto) goto = 'name';
      } else if (!this.chk('name', /^.{1,255}$/, this.res.name_toolong)) {
        isok = false;
        if (!goto) goto = 'name';
      }

      if (!this.chk('email', /^.{1,}$/, this.res.email_err)) {
        isok = false;
        if (!goto) goto = 'email';
      } else if (!this.chk('email', /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i, this.res.contact_email_invalid)) {
        isok = false;
        if (!goto) goto = 'email';
      }
      this.$root.$emit('cpassword');
      this.$root.$emit('ppassword');
      if (this.company.password != null) {
        this.company.password  = this.company.password.trim();
      }
      if (this.company.password != null && this.company.password.trim() != '') {
        if (this.company.password != this.company.cpassword) {
          if (!goto) goto = 'pwd';
          isok = false;
          this.$root.$emit('cpassword', {"error":this.res.cpassword_err});
        }
        if (this.company.ppassword == '') {
          if (!goto) goto = 'pwd';
          isok = false;
          this.$root.$emit('ppassword', {"error":this.res.ppassword_err});
        }
      }

      if (!this.chk('poc', /^.{1,}$/, this.res.poc_err)) {
        isok = false;
        if (!goto) goto = 'poc';
      } else if (!this.chk('poc', /^.{1,255}$/, this.res.poc_toolong)) {
        isok = false;
        if (!goto) goto = 'poc';
      }

      if (!this.chk('tel', /^.{1,}$/, this.res.tel_err)) {
        isok = false;
        if (!goto) goto = 'tel';
      } else if (!this.chk('tel', /^[0-9]{8,50}$/, this.res.tel_invalid)) {
        isok = false;
        if (!goto) goto = 'tel';
      }

      if (!this.chk('fb', /^$|^[A-Za-z0-9_\-\.]+$/, this.res.socialname_err, /https?:\/\/(www\.)?facebook\.com\//g)) {
        isok = false;
        if (!goto) goto = 'fb';
      } else if (!this.chk('fb', /^.{0,100}$/, this.res.socialname_toolong)) {
        isok = false;
        if (!goto) goto = 'fb';
      }

      if (!this.chk('ig', /^$|^[A-Za-z0-9_\-\.]+$/, this.res.socialname_err, /https?:\/\/(www\.)?instagram\.com\//g)) {
        isok = false;
        if (!goto) goto = 'ig';
      } else if (!this.chk('ig', /^.{0,100}$/, this.res.socialname_toolong)) {
        isok = false;
        if (!goto) goto = 'ig';
      }

      if (!this.chk('address1', /^.{1,}$/, this.res.addr1_err)) {
        if (!goto) goto = 'address1';
        isok = false;
      } else if (!this.chk('address1', /^.{1,255}$/, this.res.addr1_toolong)) {
        isok = false;
        if (!goto) goto = 'address1';
      }

      if (!this.chk('address2', /^.{0,255}$/, this.res.addr2_toolong)) {
        isok = false;
        if (!goto) goto = 'address2';
      }
      if (!this.chk('address3', /^.{0,255}$/, this.res.addr3_toolong)) {
        isok = false;
        if (!goto) goto = 'address3';
      }
      if (!this.chk('address4', /^.{0,255}$/, this.res.addr4_toolong)) {
        isok = false;
        if (!goto) goto = 'address4';
      }

      if (isok) {
        utils.saveData({
            url: utils.getServerPath()+'/account/updCompany.is',
            mode: 'update',
            repos: 'db',
            value: utils.saveJSONToForm(this.company),
            name: 'account.branch'
          }, function(success, data) {
            if (success) {
              if (data.success != 1) {
                if (data.form) {
                  Object.keys(data.form).forEach(function(key) {
                    if (data.form[key] != 0) {
                      this.$root.$emit(key, {"error":" Invalid value"});
                      $("#a_"+key)[0].scrollIntoView();
                    }
                  });
                }
                if (data.success == -2) {
                  $("#a_email")[0].scrollIntoView();
                  self.$root.$emit('email', {"error":self.res.email_used});
                } else if (data.success == -3) {
                  $("#a_email")[0].scrollIntoView();
                  self.$root.$emit('email', {"error":self.res.email_used});
                } else if (data.success == -4) {
                  $("#a_email")[0].scrollIntoView();
                  self.$root.$emit('email', {"error":self.res.email_used});
                } else if (data.success == -5) {
                  $("#pwd")[0].scrollIntoView();
                  self.$root.$emit('ppassword', {"error":self.res.wrong_password});
                }
                self.$forceUpdate();
              } else {
                self.$root.$emit('savedCompany', data.saved);
              }
            }
            self.submitted = false;
            //grecaptcha.reset();
        });
      } else {
        //grecaptcha.reset();
        self.submitted = false;
        if (goto) {
          $("#a_"+goto)[0].scrollIntoView();
          goto = null;
        }
        self.$forceUpdate();
      }
    },
    chooseLocale: function(evt, locale) {
      this.comlocale= locale;
      this.company.locale = locale.id;
      this.showLocale = false;
    },
    createBranch: function(evt) {
      this.ebranch = {"custid":this.company.custid};
      window.scrollTo(0,0);
    },
    chk: function(name, regex, errmsg, remove_regex) {
      if (remove_regex && this.company[name] != null) {
        this.company[name] = this.company[name].replace(remove_regex, '');
      }
      if (regex) {
        var chkval = (this.company[name])?this.company[name]:'';
        if (!regex.test(chkval)) {
          if (!errmsg) errmsg = " This is required";
          this.$root.$emit(name, {"error":errmsg});
          return false;
        } else {
          this.$root.$emit(name);
          return true;
        }
      }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    }
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account.vue